
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";
import { fetchTeacherList } from "../../hooks/fetchTeacherList";
import { fetchAllClasses } from "../../hooks/fetchAllClasses";
import useFetchSections from "../../hooks/useFetchSections";
import { fetchSubjectList } from "../../hooks/fetchSubjectList";
import "./AdmAttendanceEntry.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const dateRef = useRef();
  const teacherRef = useRef(null);
  const classRef = useRef(null);
  const sectionRef = useRef(null);
  const periodRef = useRef(null);
  const subjectRef = useRef(null);
  const assignmentDetailsRef = useRef(null);
  const fatherSmsRef = useRef(null);
  const motherSmsRef = useRef(null);
  const uploadRef = useRef(null);
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [remainingChars, setRemainingChars] = useState(5000);
  const [classes, setClasses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [formData, setFormData] = useState({
    selectedClassId: "",
    admitted_section: "",
    subjectId: "",
    periodId: "",
    assignmentDate: "",
  });

  const [periods, setPeriods] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const formatPeriodLabel = (period) => {
    if (!period) return "";
    const name = period.periodName || period.period_name || "";
    const description = period.period_description || "";
    const time = period.periodTime || period.period_time || "";
    const parts = [name];
    if (description && description !== name) {
      parts.push(description);
    }
    if (time) {
      parts.push(time);
    }
    return parts.filter(Boolean).join(" - ");
  };

  const { sections } = useFetchSections(formData.selectedClassId);
  const [assignments, setAssignments] = useState([]);
  const [dropdownData, setDropdownData] = useState({
    teacherName: "",
    classname: "",
    sectionname: "",
    subjectName: "",
    periodName: "",
  });
  const [smsRecipient, setSmsRecipient] = useState("B");

  // 08192025
  const [filters, setFilters] = useState({
    assignmentDate: "",
    teacherId: "",
    classId: "",
    sectionId: "",
    subjectId: "",
    periodId: "",
    assignmentDetails: ""
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // change as needed
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAssignments = assignments.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(assignments.length / itemsPerPage);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1); // react-paginate uses 0-based indexing
  };

  const todayDate = new Date().toISOString().split("T")[0];

  // Helper function to convert SMS recipient code to readable text
  const getSmsRecipientText = (recipientCode) => {
    if (!recipientCode || recipientCode.trim() === "") {
      return "-";
    }
    const code = recipientCode.trim().toUpperCase();
    switch (code) {
      case "B":
        return "Both";
      case "M":
        return "Mother";
      case "F":
        return "Father";
      default:
        return recipientCode; // Display as-is if it's already a text value like "Both"
    }
  };

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setFormData((prevData) => ({ ...prevData, assignmentDate: currentDate }));
    localStorage.setItem("assignmentDate", currentDate);
  }, []);

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    if (orgId && branchId) {
      const apiUrl = `${ApiUrl.apiurl}CLASS_PERIOD/GetCLASSPERIODLIST/${orgId}/${branchId}/`;
      fetch(apiUrl)
        .then((response) =>
          response.ok ? response.json() : Promise.reject(response.status)
        )
        .then((data) => {
          setPeriods(data.data || []);
        })
        .catch(() => console.error("Failed to load periods."));
    }
  }, []);

  const fetchTeacherListData = async (assignmentDate) => {
    const academicYearId = 1;
    try {
      const teacherList = await fetchTeacherList(
        academicYearId,
        assignmentDate
      );
      setTeachers(teacherList);
    } catch (error) {
      console.error("Error fetching teacher list:", error);
    }
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      assignmentDate: selectedDate,
    }));

    localStorage.setItem("assignmentDate", selectedDate);
    // setPeriods([]);
    setSubjects([]);
    setTeachers([]);
    setFormData((prevData) => ({
      ...prevData,
      subjectId: "",
      periodId: "",
      teacherId: "",
    }));
    localStorage.removeItem("selected_subject");
    localStorage.removeItem("subjectId");
    localStorage.removeItem("selected_periodId");
    localStorage.removeItem("selectedTeacherId");
    localStorage.removeItem("teacherId");
  };

  // Add this reset function
 const resetAssignmentFields = () => {
   setFormData({
     selectedClassId: "",
     admitted_section: "",
     subjectId: "",
     periodId: "",
     assignmentDate: todayDate,
     assignmentDetails: "",
     teacherId: "",
     sectionId: "",
   });

   setDropdownData({
     teacherName: "",
     classname: "",
     sectionname: "",
     subjectName: "",
     periodName: "",
   });

   setSubjects([]);
   // setClasses([]);  ← removed, same reasoning as handleClear
   setTeachers([]);

   localStorage.removeItem("selected_subject");
   localStorage.removeItem("subjectId");
   localStorage.removeItem("selected_periodId");
   localStorage.removeItem("selectedTeacherId");
   localStorage.removeItem("teacherId");

   if (uploadRef.current) uploadRef.current.value = null;
   if (assignmentDetailsRef.current) assignmentDetailsRef.current.value = "";
   if (fatherSmsRef.current) fatherSmsRef.current.checked = false;
   if (motherSmsRef.current) motherSmsRef.current.checked = false;

   setIsSmsChecked(false);
   setSmsRecipient("B");
   setMessage("");
   setRemainingChars(5000);
 };

  // const fetchAssignments = async () => {
  //   try {
  //     const academicSessionId = localStorage.getItem("academicSessionId");
  //     const orgId = localStorage.getItem("orgId");
  //     const branchId = localStorage.getItem("branchId");

  //     const response = await fetch(
  //       `${ApiUrl.apiurl}ASSIGNMENT/GetAllassignmentList/${academicSessionId}/${orgId}/${branchId}`
  //     );
  //     const data = await response.json();

  //     if (data.message === "Success" && data.data && data.data.length > 0) {
  //       setAssignments(data.data);
  //     } else {
  //       // ✅ clear the table if no data
  //       setAssignments([]);
  //       console.warn("No assignments found for this session.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching assignments:", error);
  //     // ✅ also clear table on error
  //     setAssignments([]);
  //   }
  // };

  //08222025
  const [lastSessionId, setLastSessionId] = useState(localStorage.getItem("academicSessionId"));

  // const fetchAssignments = async () => {
  //   try {
  //     const academicSessionId = localStorage.getItem("academicSessionId");
  //     const orgId = localStorage.getItem("orgId");
  //     const branchId = localStorage.getItem("branchId");

  //     // ✅ Reset fields if session changed
  //     if (lastSessionId !== academicSessionId) {
  //       resetAssignmentFields();
  //       setLastSessionId(academicSessionId);
  //     }

  //     const response = await fetch(
  //       `${ApiUrl.apiurl}ASSIGNMENT/GetAllassignmentList/${academicSessionId}/${orgId}/${branchId}`
  //     );
  //     const data = await response.json();

  //     if (data.message === "Success" && data.data && data.data.length > 0) {
  //       setAssignments(data.data);
  //     } else {
  //       setAssignments([]);
  //       console.warn("No assignments found for this session.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching assignments:", error);
  //     setAssignments([]);
  //   }
  // };

  const fetchAssignments = async () => {
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const baseUrl = `${ApiUrl.apiurl}ASSIGNMENT/GetAllassignmentList/${orgId}/${branchId}/${academicSessionId}`;

      // ✅ Reset fields if session changed
      if (lastSessionId !== academicSessionId) {
        resetAssignmentFields();
        setLastSessionId(academicSessionId);
      }

      // ✅ Collect filter values from formData
      const {
        assignmentDate,
        teacherId,
        selectedClassId,
        classId,
        sectionId,
        admitted_section,
        subjectId,
        periodId,
        assignmentDetails,
      } = formData;

      // Avoid sending empty filters because backend may treat empty values as strict filters.
      const queryParams = new URLSearchParams();
      const appendFilter = (key, value) => {
        if (value !== undefined && value !== null && String(value).trim() !== "") {
          queryParams.append(key, String(value));
        }
      };

      appendFilter("assignmentDate", assignmentDate);
      appendFilter("teacherId", teacherId);
      appendFilter("classId", selectedClassId || classId);
      appendFilter("sectionId", sectionId || admitted_section);
      appendFilter("subjectId", subjectId);
      appendFilter("periodId", periodId);
      appendFilter("assignmentDetails", assignmentDetails);

      const queryString = queryParams.toString();
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

      const response = await fetch(url);
      const data = await response.json();
      const isSuccessMessage =
        typeof data?.message === "string" &&
        data.message.toLowerCase().includes("success");

      let assignmentRows = isSuccessMessage && Array.isArray(data?.data) ? data.data : [];

      // Fallback to unfiltered list when filtered fetch returns empty.
      if (assignmentRows.length === 0 && queryString) {
        const fallbackResponse = await fetch(baseUrl);
        const fallbackData = await fallbackResponse.json();
        const isFallbackSuccess =
          typeof fallbackData?.message === "string" &&
          fallbackData.message.toLowerCase().includes("success");

        assignmentRows =
          isFallbackSuccess && Array.isArray(fallbackData?.data)
            ? fallbackData.data
            : [];
      }

      setAssignments(assignmentRows);
      setCurrentPage(1);

      if (assignmentRows.length === 0) {
        console.warn("No assignments found for the given filter.");
      }
    } catch (error) {
      console.error("Error fetching assignments:", error);
      setAssignments([]);
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, []);

  // const handleDownload = (fileUrl) => {
  //   if (!fileUrl) {
  //     console.error("No file URL provided");
  //     return;
  //   }

  //   const link = document.createElement("a");
  //   link.href = fileUrl;

  //   link.download = fileUrl.split("/").pop();

  //   document.body.appendChild(link);
  //   link.click();

  //   document.body.removeChild(link);
  // };

  //08192025
  const handleDownload = (fileUrl) => {
    if (!fileUrl) {
      console.error("No file URL provided");
      return;
    }

    // ✅ Automatically download
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileUrl.split("/").pop()); // filename from URL
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error("Download error:", err));
  };


  // const handleClear = () => {
  //   if (teacherRef.current) teacherRef.current.value = "";
  //   if (classRef.current) classRef.current.value = "";
  //   if (sectionRef.current) sectionRef.current.value = "";
  //   if (periodRef.current) periodRef.current.value = "";
  //   if (subjectRef.current) subjectRef.current.value = "";
  //   if (assignmentDetailsRef.current) assignmentDetailsRef.current.value = "";
  //   if (fatherSmsRef.current) fatherSmsRef.current.checked = false;
  //   if (motherSmsRef.current) motherSmsRef.current.checked = false;
  //   if (uploadRef.current) uploadRef.current.value = null;

  //   const keysToRetain = [
  //     "academicSessionId",
  //     "orgId",
  //     "branchId",
  //     "nextAcademicSessionId",
  //   ];

  //   const allKeys = Object.keys(localStorage);

  //   allKeys.forEach((key) => {
  //     if (!keysToRetain.includes(key)) {
  //       localStorage.removeItem(key);
  //     }
  //   });

  //   // window.location.reload();
  // };

 const handleClear = () => {
  // Reset all controlled form data
  setFormData({
    selectedClassId: "",
    admitted_section: "",
    subjectId: "",
    periodId: "",
    assignmentDate: todayDate,
    assignmentDetails: "",
    teacherId: "",
    sectionId: "",
  });

  setDropdownData({
    teacherName: "",
    classname: "",
    sectionname: "",
    subjectName: "",
    periodName: "",
  });


  // Reset only the dependent lists — NOT classes, since the class list
  // is fetched once on mount and doesn't depend on any selection
  setSubjects([]);
  setTeachers([]); // Optional: if you want to refetch teacher list on date change
  // setClasses([]);  ← removed: this was wiping the dropdown's option list

    // Reset lists — re-fetch classes immediately so the dropdown still works after Clear
    setSubjects([]);
    fetchAllClasses()
      .then((data) => setClasses(data))
      .catch((err) => console.error("Error re-fetching classes after clear:", err));
    setTeachers([]); // Optional: if you want to refetch teacher list on date change

  if (uploadRef.current) uploadRef.current.value = null;
  if (assignmentDetailsRef.current) assignmentDetailsRef.current.value = "";
  if (fatherSmsRef.current) fatherSmsRef.current.checked = false;
  if (motherSmsRef.current) motherSmsRef.current.checked = false;

  setIsSmsChecked(false);
  setSmsRecipient("B");
  setMessage("");
  setRemainingChars(5000);

  const keysToRetain = [
    "academicSessionId",
    "orgId",
    "branchId",
    "nextAcademicSessionId",
    "assignmentDate",
  ];
  const allKeys = Object.keys(localStorage);
  allKeys.forEach((key) => {
    if (!keysToRetain.includes(key)) {
      localStorage.removeItem(key);
    }
  });

  localStorage.removeItem("selected_subject");
  localStorage.removeItem("subjectId");
  localStorage.removeItem("selected_periodId");
  localStorage.removeItem("selectedTeacherId");
  localStorage.removeItem("teacherId");

  setIsEditMode(false);
};

  const [message, setMessage] = useState("");
  const [isSmsChecked, setIsSmsChecked] = useState(false);

  // const handleTextareaChange = (event) => {
  //   const inputMessage = event.target.value;

  //   setFormData((prevState) => ({
  //     ...prevState,
  //     assignmentDetails: inputMessage,
  //   }));

  //   if (remainingChars <= 0 && inputMessage.length > message.length) {
  //     return;
  //   }

  //   setMessage(inputMessage);
  //   if (isSmsChecked) {
  //     setRemainingChars(159 - inputMessage.length);
  //   } else {
  //     setRemainingChars(5000 - inputMessage.length);
  //   }
  // };

  const handleTextareaChange = (event) => {
    let inputMessage = event.target.value;

    // If SMS is checked, limit to 159 chars
    if (isSmsChecked && inputMessage.length > 159) {
      inputMessage = inputMessage.slice(0, 159);
    }

    setFormData((prevState) => ({
      ...prevState,
      assignmentDetails: inputMessage,
    }));

    setMessage(inputMessage);
    setRemainingChars(
      isSmsChecked ? 159 - inputMessage.length : 5000 - inputMessage.length
    );
  };

  const handleRadioChange = () => {
    setIsSmsChecked((prevState) => {
      const newState = !prevState;
      if (newState) {
        setRemainingChars(159 - message.length);
      } else {
        setRemainingChars(5000 - message.length);
      }
      return newState;
    });
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];

    if (dateRef.current) {
      dateRef.current.value = formattedDate;

      localStorage.setItem("assignmentDate", formattedDate);
    }
  }, []);

  const [errors, setError] = useState(null);

  useEffect(() => {
    setTeachers([]);
  }, []);

  const handleTeacherChange = (event) => {
    const selectedTeacherId = event.target.value;

    if (selectedTeacherId) {
      localStorage.setItem("selectedTeacherId", selectedTeacherId);
      localStorage.setItem("teacherId", selectedTeacherId);
      setFormData((prevData) => ({
        ...prevData,
        teacherId: selectedTeacherId,
      }));

      fetchAllClasses()
        .then((data) => {
          setClasses(data);
        })
        .catch((err) => {
          console.error("Error:", err);
          setError("Failed to load classes");
        });
    } else {
      localStorage.removeItem("selectedTeacherId");
      localStorage.removeItem("teacherId");
      setFormData((prevData) => ({
        ...prevData,
        teacherId: "",
      }));
      setDropdownData((prev) => ({ ...prev, teacherName: "" }));
    }
  };

  useEffect(() => {
    fetchAllClasses().then((data) => {
      setClasses(data);
    });
  }, []);

  const handleClassChange = (event) => {
    const selectedClassId = event.target.value;

    setFormData((prevData) => ({
      ...prevData,
      selectedClassId: selectedClassId,
      sectionId: "",
      subjectId: "",
      periodId: "",
      teacherId: "",
    }));

    localStorage.setItem("selectedClassId", selectedClassId);
    localStorage.removeItem("admitted_section");
    localStorage.removeItem("selected_subject");
    localStorage.removeItem("selected_periodId");
    localStorage.removeItem("selectedTeacherId");
    // setPeriods([]);
    setSubjects([]);
    setTeachers([]);
    setDropdownData((prev) => ({
      ...prev,
      sectionname: "",
      subjectName: "",
      periodName: "",
      teacherName: "",
    }));
  };

  const fetchPeriods = async (
    academicSessionId,
    assignmentDate,
    selectedTeacherId,
    selectedClassId,
    admittedSection,
    selectedSubject
  ) => {
    if (
      academicSessionId &&
      assignmentDate &&
      selectedTeacherId &&
      selectedClassId &&
      admittedSection &&
      selectedSubject
    ) {
      const apiUrl = `${ApiUrl.apiurl}Teacher/GetPeriodListBasedOnSubject/${academicSessionId}/${assignmentDate}/${selectedTeacherId}/${selectedClassId}/${admittedSection}/${selectedSubject}`;
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (result && result.data) {
        setPeriods(result.data);
      } else {
        // setPeriods([]);
      }
    }
  };

  const handleSectionChange = async (e) => {
    const sectionId = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      sectionId: sectionId,
      subjectId: "",
      periodId: "",
      teacherId: "",
    }));

    localStorage.setItem("admitted_section", sectionId);
    localStorage.removeItem("selected_subject");
    localStorage.removeItem("selected_periodId");
    localStorage.removeItem("selectedTeacherId");
    // setPeriods([]);
    setSubjects([]);
    setTeachers([]);
    setDropdownData((prev) => ({
      ...prev,
      subjectName: "",
      periodName: "",
      teacherName: "",
    }));
  };

  useEffect(() => {
    const admittedSection = localStorage.getItem("admitted_section");
    if (admittedSection) {
      setFormData((prevData) => ({
        ...prevData,
        admitted_section: admittedSection,
      }));
    }
  }, []);

  const handleSubjectChange = (e) => {
    const subjectId = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      subjectId,
    }));

    localStorage.setItem("selected_subject", subjectId);
    localStorage.setItem("subjectId", subjectId);
    setDropdownData((prev) => ({
      ...prev,
      subjectName:
        subjects.find(
          (subject) => String(subject.subjectId) === String(subjectId)
        )?.subjectname || "",
    }));
  };

  useEffect(() => {
    const academicSessionId = localStorage.getItem("academicSessionId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const assignmentDate =
      formData.assignmentDate || localStorage.getItem("assignmentDate");
    const classId =
      formData.selectedClassId || localStorage.getItem("selectedClassId");
    const sectionId =
      formData.sectionId || formData.admitted_section || localStorage.getItem("admitted_section");
    const periodId = formData.periodId || localStorage.getItem("selected_periodId");

    if (
      !academicSessionId ||
      !orgId ||
      !branchId ||
      !assignmentDate ||
      !classId ||
      !sectionId ||
      !periodId
    ) {
      setSubjects([]);
      setTeachers([]);
      return;
    }

    const fetchTimetableLinks = async () => {
      try {
        const apiUrl = `${ApiUrl.apiurl}FILTER/GetSUBJECTTEACHERBASEDONPERIOD/?academic_year_id=${academicSessionId}&org_id=${orgId}&branch_id=${branchId}&date=${assignmentDate}&classId=${classId}&sectionId=${sectionId}&claasPeriodId=${periodId}`;
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const data = await response.json();

        if (
          data?.message === "success" &&
          Array.isArray(data.data) &&
          data.data.length > 0
        ) {
          const subjectOptions = data.data.map((item) => ({
            subjectId: item.subjectId,
            subjectname: item.subjectname,
          }));
          const teacherOptions = data.data.map((item) => ({
            teacherId: item.teacherId,
            TeacherName: item.teachername,
          }));
          const first = data.data[0];

          setSubjects(subjectOptions);
          setTeachers(teacherOptions);
          setFormData((prevData) => ({
            ...prevData,
            subjectId: first.subjectId,
            teacherId: first.teacherId,
          }));
          setDropdownData((prev) => ({
            ...prev,
            subjectName: first.subjectname || "",
            teacherName: first.teachername || "",
          }));
          localStorage.setItem("subjectId", first.subjectId);
          localStorage.setItem("teacherId", first.teacherId);
          localStorage.setItem("selected_subject", first.subjectId);
          localStorage.setItem("selectedTeacherId", first.teacherId);
        } else {
          setSubjects([]);
          setTeachers([]);
          setFormData((prevData) => ({
            ...prevData,
            subjectId: "",
            teacherId: "",
          }));
          setDropdownData((prev) => ({
            ...prev,
            subjectName: "",
            teacherName: "",
          }));
          localStorage.removeItem("subjectId");
          localStorage.removeItem("teacherId");
          localStorage.removeItem("selected_subject");
          localStorage.removeItem("selectedTeacherId");
        }
      } catch (error) {
        console.error("Error fetching timetable subject/teacher data:", error);
        setSubjects([]);
        setTeachers([]);
        localStorage.removeItem("subjectId");
        localStorage.removeItem("teacherId");
      }
    };

    fetchTimetableLinks();
  }, [
    formData.assignmentDate,
    formData.selectedClassId,
    formData.admitted_section,
    formData.sectionId,
    formData.periodId,
  ]);

  const handleEditClick = async (assignmentId) => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}ASSIGNMENT/GetAssignmentBasedId/${assignmentId}`
      );
      const data = await response.json();
      console.log(data);

      if (data.message === "Success") {
        const assignmentDetails = data.data;

        setFormData({
          assignmentId: assignmentDetails.id,
          assignmentDate: assignmentDetails.assignment_date || "",
          teacherId: assignmentDetails.teacherId || "",
          classId: assignmentDetails.classId || "",
          sectionId: assignmentDetails.sectionId || "",
          subjectId: assignmentDetails.subjectId || "",
          periodId: assignmentDetails.classperiodId || "",
          assignmentDetails: assignmentDetails.assignment_details || "",
          sendSms: assignmentDetails.send_sms || "N",
          smsSentTo: assignmentDetails.sms_sent_to || "B",
        });

        setDropdownData({
          teacherName: assignmentDetails.teacherName || "",
          classname: assignmentDetails.classname || "",
          sectionname: assignmentDetails.sectionname || "",
          subjectName: assignmentDetails.subjectName || "",
          periodName: assignmentDetails.classperiodName || "",
        });

        setIsSmsChecked(assignmentDetails.send_sms === "Y");
        setSmsRecipient(assignmentDetails.sms_sent_to || "B");

        localStorage.setItem("assignmentId", assignmentDetails.id || "");
        localStorage.setItem(
          "assignmentDate",
          assignmentDetails.assignment_date || ""
        );
        localStorage.setItem(
          "selectedTeacherId",
          assignmentDetails.teacherId || ""
        );
        localStorage.setItem("selectedClassId", assignmentDetails.classId || "");
        localStorage.setItem(
          "selectedSectionId",
          assignmentDetails.sectionId || ""
        );
        localStorage.setItem(
          "selectedSubjectId",
          assignmentDetails.subjectId || ""
        );
        localStorage.setItem(
          "selectedPeriodId",
          assignmentDetails.classperiodId || ""
        );

        const academicSessionId = localStorage.getItem("academicSessionId");
        const assignmentDate = assignmentDetails.assignment_date || "";

        if (academicSessionId && assignmentDate) {
          const teacherListResponse = await fetch(
            `${ApiUrl.apiurl}Teacher/GetTeacherListBasedOnDay/${academicSessionId}/${assignmentDate}`
          );
          const teacherListData = await teacherListResponse.json();

          if (teacherListData && teacherListData.message === "success!!") {
            setTeachers(teacherListData.data || []);
          } else {
            console.error(
              "Failed to fetch teacher list:",
              teacherListData.message
            );
          }
        } else {
          console.error("Academic Session ID or Assignment Date is missing");
        }

        // ✅ Turn on edit mode to disable Teacher, Class, Section, Subject and Period
        setIsEditMode(true);
        // ✅ Scroll to top after filling edit form
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        console.error("Error fetching assignment details:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const handleSave = async () => {
  //   const formDataToSend = new FormData();

  //   const assignmentId = localStorage.getItem("editAssignmentId");
  //   const isEdit = !!assignmentId;

  //   const academicYearId = localStorage.getItem("academicSessionId");
  //   const classId = localStorage.getItem("selectedClassId");
  //   const sectionId = localStorage.getItem("admitted_section");
  //   const subjectId = localStorage.getItem("selected_subject");
  //   const classPeriodId = localStorage.getItem("selected_periodId");
  //   const assignmentDetails = formData.assignmentDetails || "";
  //   const teacherId = localStorage.getItem("selectedTeacherId");

  //   formDataToSend.append("academic_year_id", academicYearId);
  //   formDataToSend.append("class_id", classId);
  //   formDataToSend.append("section_id", sectionId);
  //   formDataToSend.append("subject_id", subjectId);
  //   formDataToSend.append("assignment_date", dateRef.current.value);
  //   formDataToSend.append("assignment_details", assignmentDetails);
  //   formDataToSend.append("org_id", localStorage.getItem("orgId"));
  //   formDataToSend.append("branch_id", localStorage.getItem("branchId"));
  //   formDataToSend.append("class_period_id", classPeriodId);
  //   formDataToSend.append("teacher_id", teacherId);

  //   const selectedSmsOption = document.querySelector(
  //     'input[name="smsRecipient"]:checked'
  //   );
  //   const smsRecipient = selectedSmsOption ? selectedSmsOption.value : "B";

  //   formDataToSend.append("send_sms", isSmsChecked ? "Y" : "N");
  //   formDataToSend.append("sms_sent_to", smsRecipient);
  //   formDataToSend.append("is_active", true);
  //   formDataToSend.append("created_by", sessionStorage.getItem("userId"));

  //   const fileInput = uploadRef.current.files[0];
  //   if (fileInput) {
  //     formDataToSend.append("assignment_file", fileInput);
  //   }

  //   try {
  //     const apiUrl = isEdit
  //       ? `${ApiUrl.apiurl}ASSIGNMENT/UpdateAssignment/${assignmentId}`
  //       : `${ApiUrl.apiurl}ASSIGNMENT/CreateAllassignment/`;

  //     const response = await fetch(apiUrl, {
  //       method: isEdit ? "PUT" : "POST",
  //       body: formDataToSend,
  //     });

  //     // if (response.ok) {
  //     //   const result = await response.json();
  //     //   alert(
  //     //     result.message ||
  //     //     (isEdit
  //     //       ? "Assignment Updated Successfully!"
  //     //       : "Assignment Added Successfully!")
  //     //   );

  //     //   if (isEdit) {
  //     //     localStorage.removeItem("editAssignmentId");
  //     //   }

  //     //   // ✅ Refresh table immediately
  //     //   fetchAssignments();

  //     //   // ✅ Optionally clear form after save
  //     //   setFormData({ assignmentDetails: "" });
  //     //   dateRef.current.value = "";
  //     //   if (uploadRef.current) uploadRef.current.value = null;

  //     // } else {
  //     //   const error = await response.json();
  //     //   console.error("Error response:", error);
  //     //   alert(
  //     //     error.assignment_file?.[0] ||
  //     //     (isEdit
  //     //       ? "Failed to update assignment for the specified criteria!"
  //     //       : "Assignment already exists for the specified criteria!")
  //     //   );
  //     // }
  //     if (response.ok) {
  //       const result = await response.json();
  //       alert(
  //         result.message ||
  //         (isEdit
  //           ? "Assignment Updated Successfully!"
  //           : "Assignment Added Successfully!")
  //       );

  //       if (isEdit) {
  //         localStorage.removeItem("editAssignmentId");
  //       }

  //       // ✅ Refresh table immediately
  //       fetchAssignments();

  //       // ✅ Reset fields with your required defaults
  //       const todayDate = new Date().toISOString().split("T")[0];
  //       setFormData({
  //         assignmentDetails: "",
  //       });

  //       // Reset date to today
  //       if (dateRef.current) {
  //         dateRef.current.value = todayDate;
  //       }

  //       // Clear upload file
  //       if (uploadRef.current) {
  //         uploadRef.current.value = null;
  //       }

  //       // Reset SMS options
  //       setIsSmsChecked(false);   // Send SMS unchecked
  //       setSmsRecipient("B");     // Both selected
  //       if (fatherSmsRef.current) fatherSmsRef.current.checked = false;
  //       if (motherSmsRef.current) motherSmsRef.current.checked = false;

  //     } else {
  //       const error = await response.json();
  //       console.error("Error response:", error);
  //       alert(
  //         error.assignment_file?.[0] ||
  //         (isEdit
  //           ? "Failed to update assignment for the specified criteria!"
  //           : "Assignment already exists for the specified criteria!")
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error saving assignment:", error);
  //   }
  // };

  //08222025
  const handleSave = async () => {
    const formDataToSend = new FormData();

    const assignmentId = localStorage.getItem("editAssignmentId");
    const isEdit = !!assignmentId;

    const academicYearId = localStorage.getItem("academicSessionId");
    const classId = localStorage.getItem("selectedClassId");
    const sectionId = localStorage.getItem("admitted_section");
    const subjectId = localStorage.getItem("selected_subject");
    const classPeriodId = localStorage.getItem("selected_periodId");
    const assignmentDetails = formData.assignmentDetails || "";
    const teacherId = localStorage.getItem("selectedTeacherId");

    if (!assignmentDetails.trim()) {
      alert("Assignment Details is mandatory. Please enter assignment details.");
      if (assignmentDetailsRef.current) {
        assignmentDetailsRef.current.focus();
      }
      return;
    }

    formDataToSend.append("academic_year_id", academicYearId);
    formDataToSend.append("class_id", classId);
    formDataToSend.append("section_id", sectionId);
    formDataToSend.append("subject_id", subjectId);
    formDataToSend.append("assignment_date", dateRef.current.value);
    formDataToSend.append("assignment_details", assignmentDetails);
    formDataToSend.append("org_id", localStorage.getItem("orgId"));
    formDataToSend.append("branch_id", localStorage.getItem("branchId"));
    formDataToSend.append("class_period_id", classPeriodId);
    formDataToSend.append("teacher_id", teacherId);

    const selectedSmsOption = document.querySelector(
      'input[name="smsRecipient"]:checked'
    );
    const smsRecipient = selectedSmsOption ? selectedSmsOption.value : "B";

    formDataToSend.append("send_sms", isSmsChecked ? "Y" : "N");
    formDataToSend.append("sms_sent_to", smsRecipient);
    formDataToSend.append("is_active", true);
    formDataToSend.append("created_by", sessionStorage.getItem("userId"));

    const fileInput = uploadRef.current.files[0];
    if (fileInput) {
      formDataToSend.append("assignment_file", fileInput);
    }

    try {
      const apiUrl = isEdit
        ? `${ApiUrl.apiurl}ASSIGNMENT/UpdateAssignment/${assignmentId}`
        : `${ApiUrl.apiurl}ASSIGNMENT/CreateAllassignment/`;

      const response = await fetch(apiUrl, {
        method: isEdit ? "PUT" : "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        const result = await response.json();
        alert(
          result.message ||
          (isEdit
            ? "Assignment Updated Successfully!"
            : "Assignment Added Successfully!")
        );

        if (isEdit) {
          localStorage.removeItem("editAssignmentId");
        }

        // ✅ Refresh table
        fetchAssignments();

        // ✅ Reset fields with defaults after save
        const todayDate = new Date().toISOString().split("T")[0];

        setFormData((prevData) => ({
          ...prevData,
          assignmentDate: todayDate,
          assignmentDetails: "",
        }));

        // Reset date to today
        if (dateRef.current) {
          dateRef.current.value = todayDate;
        }

        // Clear upload file
        if (uploadRef.current) {
          uploadRef.current.value = null;
        }

        // Reset SMS options
        setIsSmsChecked(false);   // Send SMS unchecked
        setSmsRecipient("B");     // Both selected
        if (fatherSmsRef.current) fatherSmsRef.current.checked = false;
        if (motherSmsRef.current) motherSmsRef.current.checked = false;

      } else {
        const error = await response.json();
        console.error("Error response:", error);
        alert(
          error.assignment_file?.[0] ||
          (isEdit
            ? "Failed to update assignment for the specified criteria!"
            : "Assignment already exists for the specified criteria!")
        );
      }
    } catch (error) {
      console.error("Error saving assignment:", error);
      alert("Something went wrong while saving the assignment ❌");
    }
  };

  // const handleUpdateClick = async () => {
  //   const assignmentId = formData.assignmentId;

  //   if (!assignmentId) {
  //     console.error("Assignment ID is missing.");
  //     return;
  //   }

  //   const updatedAssignmentData = {
  //     academic_year_id: localStorage.getItem("academicSessionId") || null,
  //     class_id: formData.classId || null,
  //     section_id: formData.sectionId || null,
  //     subject_id: formData.subjectId || null,
  //     assignment_date: formData.assignmentDate || null,
  //     assignment_file: null,
  //     assignment_details: formData.assignmentDetails || "",
  //     org_id: localStorage.getItem("orgId") || null,
  //     branch_id: localStorage.getItem("branchId") || null,
  //     class_period_id: formData.periodId || null,
  //     teacher_id: formData.teacherId || null,
  //     send_sms: formData.sendSms || "",
  //     sms_sent_to: formData.smsSentTo || "",
  //     updated_by: sessionStorage.getItem("userId") || null,
  //   };

  //   try {
  //     console.log("Sending update request with data:", updatedAssignmentData);

  //     const updateResponse = await fetch(
  //       `${ApiUrl.apiurl}ASSIGNMENT/updateassignment/${assignmentId}`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(updatedAssignmentData),
  //       }
  //     );

  //     const updateData = await updateResponse.json();

  //     console.log("API response:", updateData);

  //     if (updateData.message === "Assignment updated successfully.") {
  //       alert("Updated successfully!");
  //     } else {
  //       console.error("Failed to update assignment:", updateData.message);
  //       alert("Failed to update assignment. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating assignment:", error);
  //     alert("Failed to update assignment. Please try again.");
  //   }
  // };


  //08192025
  const handleUpdateClick = async () => {
    const assignmentId = formData.assignmentId;

    if (!assignmentId) {
      console.error("Assignment ID is missing.");
      return;
    }

    const formDataToSend = new FormData();

    formDataToSend.append("academic_year_id", localStorage.getItem("academicSessionId") || "");
    formDataToSend.append("class_id", formData.classId || "");
    formDataToSend.append("section_id", formData.sectionId || "");
    formDataToSend.append("subject_id", formData.subjectId || "");
    formDataToSend.append("assignment_date", formData.assignmentDate || "");
    formDataToSend.append("assignment_details", formData.assignmentDetails || "");
    formDataToSend.append("org_id", localStorage.getItem("orgId") || "");
    formDataToSend.append("branch_id", localStorage.getItem("branchId") || "");
    formDataToSend.append("class_period_id", formData.periodId || "");
    formDataToSend.append("teacher_id", formData.teacherId || "");
    formDataToSend.append("send_sms", formData.sendSms || "");
    formDataToSend.append("sms_sent_to", formData.smsSentTo || "");
    formDataToSend.append("updated_by", sessionStorage.getItem("userId") || "");

    // ✅ add file only if a new one is selected, otherwise send old reference
    if (uploadRef.current && uploadRef.current.files[0]) {
      formDataToSend.append("assignment_file", uploadRef.current.files[0]);
    } else if (formData.assignment_file) {
      // old file path from DB
      formDataToSend.append("assignment_file_reference", formData.assignment_file);
    }

    try {
      const updateResponse = await fetch(
        `${ApiUrl.apiurl}ASSIGNMENT/updateassignment/${assignmentId}`,
        {
          method: "PUT",
          body: formDataToSend,
        }
      );

      const updateData = await updateResponse.json();

      console.log("API response:", updateData);

      if (updateResponse.ok && updateData.message === "Assignment updated successfully.") {
        alert("Updated successfully!");
      } else {
        console.error("Failed to update assignment:", updateData.message);
        alert("Failed to update assignment. Please try again.");
      }
    } catch (error) {
      console.error("Error updating assignment:", error);
      alert("Failed to update assignment. Please try again.");
    }
  };

  const [data, setData] = useState(assignments);

  const handleDelete = async (id) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this assignment?"
    );
    if (!confirmation) {
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}ASSIGNMENT/deleteassignment/${id}/`,
        {
          method: "DELETE",
        }
      );

      const result = await response.json();

      if (result.message === "Assignment Deleted Successfully") {
        window.location.reload();
        setData((prevData) => prevData.filter((item) => item.id !== id));
        alert("Assignment deleted successfully.");
      } else {
        alert(`Failed to delete the assignment: ${result.message}`);
      }
    } catch (error) {
      console.error("Error deleting assignment:", error);
      alert("An error occurred while deleting the assignment.");
    }
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ASSIGNMENT
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={fetchAssignments}
                  >
                    Display
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleUpdateClick}
                    disabled={!isEditMode}  // Disable update when not editing
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                    disabled={isEditMode}   // Disable save when editing
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-3">
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="assignment-date" className="form-label">
                          Assignment Date{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          id="assignment-date"
                          className="form-control detail"
                          ref={dateRef}
                          value={formData.assignmentDate}
                          onChange={handleDateChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1" style={{ display: "none" }}>
                        <label htmlFor="teacher-hidden" className="form-label">
                          Teacher<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="teacher-hidden"
                          className="detail"
                          classNamePrefix="react-select"
                          options={teachers.map((teacher) => ({
                            value: teacher.teacherId,
                            label: teacher.TeacherName,
                          }))}
                          value={
                            teachers
                              .map((teacher) => ({
                                value: teacher.teacherId,
                                label: teacher.TeacherName,
                              }))
                              .find(
                                (option) => option.value === formData.teacherId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleTeacherChange({
                              target: { value: selectedOption?.value },
                            })
                          }
                          placeholder="Select Teacher"
                          isDisabled={isEditMode}   // ✅ disables in edit mode
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="class" className="form-label">
                          Class <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="class"
                          className="detail"
                          classNamePrefix="react-select"
                          options={classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          }))}
                          value={
                            classes
                              .map((classItem) => ({
                                value: classItem.id,
                                label: classItem.classname,
                              }))
                              .find(
                                (option) =>
                                  option.value === formData.selectedClassId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: { value: selectedOption?.value },
                            })
                          }
                          placeholder={dropdownData.classname || "Select Class"}
                          isDisabled={isEditMode}   // ✅ disables in edit mode
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Section
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="admitted-section"
                          className="detail"
                          classNamePrefix="react-select"
                          options={sections.map((section) => ({
                            value: section.id,
                            label: section.sectionname,
                          }))}
                          value={
                            sections
                              .map((section) => ({
                                value: section.id,
                                label: section.sectionname,
                              }))
                              .find(
                                (option) => option.value === formData.sectionId
                              ) || null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: { value: selectedOption?.value },
                            })
                          }
                          placeholder={
                            dropdownData.sectionname || "Select Section"
                          }
                          isDisabled={isEditMode}   // ✅ disables in edit mode
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="period" className="form-label">
                          Period <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="period"
                          className="detail"
                          classNamePrefix="react-select"
                          options={periods.map((period) => ({
                            value: period.classperiodId || period.id,
                            label: formatPeriodLabel(period),
                          }))}
                          value={
                            periods
                              .map((period) => ({
                                value: period.classperiodId || period.id,
                                label: formatPeriodLabel(period),
                              }))
                              .find(
                                (option) => option.value === formData.periodId
                              ) || null
                          }
                          onChange={(selectedOption) => {
                            const selectedPeriodId = selectedOption?.value || "";
                            setFormData((prevData) => ({
                              ...prevData,
                              periodId: selectedPeriodId,
                            }));
                            localStorage.setItem(
                              "selected_periodId",
                              selectedPeriodId
                            );
                          }}
                          placeholder={dropdownData.periodName || "Select Period"}
                          isDisabled={isEditMode}   // ✅ disables in edit mode
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row flex-grow-1">
                    <div className="col-12 col-md-3 mb-1" style={{ display: "none" }}>
                      <label htmlFor="subject" className="form-label">
                        Subject <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="subject"
                        className="detail"
                        classNamePrefix="react-select"
                        options={subjects.map((subject) => ({
                          value: subject.subjectId,
                          label: subject.subjectname,
                        }))}
                        value={
                          subjects
                            .map((subject) => ({
                              value: subject.subjectId,
                              label: subject.subjectname,
                            }))
                            .find(
                              (option) => option.value === formData.subjectId
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSubjectChange({
                            target: { value: selectedOption?.value },
                          })
                        }
                        placeholder={
                          dropdownData.subjectName || "Select Subject"
                        }
                        isDisabled={isEditMode}   // ✅ disables in edit mode
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-1">
                      <label htmlFor="subject-hidden" className="form-label">
                        Subject <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="subject-hidden"
                        className="detail"
                        classNamePrefix="react-select"
                        options={subjects.map((subject) => ({
                          value: subject.subjectId,
                          label: subject.subjectname,
                        }))}
                        value={
                          subjects
                            .map((subject) => ({
                              value: subject.subjectId,
                              label: subject.subjectname,
                            }))
                            .find(
                              (option) => option.value === formData.subjectId
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleSubjectChange({
                            target: { value: selectedOption?.value },
                          })
                        }
                        placeholder={dropdownData.subjectName || "Select Subject"}
                        isDisabled={isEditMode}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-1">
                      <label htmlFor="teacher" className="form-label">
                        Teacher<span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="teacher"
                        className="detail"
                        classNamePrefix="react-select"
                        options={teachers.map((teacher) => ({
                          value: teacher.teacherId,
                          label: teacher.TeacherName,
                        }))}
                        value={
                          teachers
                            .map((teacher) => ({
                              value: teacher.teacherId,
                              label: teacher.TeacherName,
                            }))
                            .find(
                              (option) => option.value === formData.teacherId
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleTeacherChange({
                            target: { value: selectedOption?.value },
                          })
                        }
                        placeholder="Select Teacher"
                        isDisabled={isEditMode}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-0">
                      <label htmlFor="upload" className="form-label">
                        Upload Assignment
                      </label>
                      <input
                        type="file"
                        name="upload"
                        id="upload"
                        ref={uploadRef}
                        className="form-control detail"
                      />
                    </div>
                    <div className="col-12 mt-3">
  <div
    className="d-flex align-items-center"
    style={{
      gap: "20px",
      flexWrap: "nowrap",
    }}>
    <span
      className="fw-bold mb-0"
      style={{
        whiteSpace: "nowrap",
        minWidth: "120px",
      }}
    >
      Send SMS to:
    </span>

    <div className="form-check mb-0">
      <input
        className="form-check-input"
        type="radio"
        name="smsRecipient"
        id="flexRadioDefault1"
        value="F"
        checked={smsRecipient === "F"}
        onChange={(e) => setSmsRecipient(e.target.value)}
      />
      <label
        className="form-check-label"
        htmlFor="flexRadioDefault1"
      >
        Father
      </label>
    </div>

    <div className="form-check mb-0">
      <input
        className="form-check-input"
        type="radio"
        name="smsRecipient"
        id="flexRadioDefault2"
        value="M"
        checked={smsRecipient === "M"}
        onChange={(e) => setSmsRecipient(e.target.value)}
      />
      <label
        className="form-check-label"
        htmlFor="flexRadioDefault2"
      >
        Mother
      </label>
    </div>

    <div className="form-check mb-0">
      <input
        className="form-check-input"
        type="radio"
        name="smsRecipient"
        id="flexRadioDefault3"
        value="B"
        checked={smsRecipient === "B"}
        onChange={(e) => setSmsRecipient(e.target.value)}
      />
      <label
        className="form-check-label"
        htmlFor="flexRadioDefault3"
      >
        Both
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-grow-1">
                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center flex-grow-1">
                          <div className="mb-2 me-2 d-flex align-items-center">
                            <span
                              className="me-3"
                              style={{ fontWeight: "700" }}
                            >
                              Send SMS:
                            </span>
                            <div className="d-flex flex-column me-2">
                              <div className="form-check mb-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="smsTo"
                                  id="smsToFather"
                                  checked={isSmsChecked}
                                  onChange={handleRadioChange}
                                  style={{ width: "18px", height: "18px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-grow-1 me-md-2">
                        <label
                          htmlFor="assignmentDetails"
                          className="form-label"
                        >
                          Assignment Details{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="assignmentDetails"
                          rows="3"
                          name="assignmentDetails"
                          ref={assignmentDetailsRef}
                          value={formData.assignmentDetails}
                          onChange={handleTextareaChange}
                          style={{
                            resize: "vertical",
                            overflow: "auto",
                            maxHeight: "150px",
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                        ></textarea>
                        <div className="d-flex justify-content-middle mt-1">
                          <small className="text-muted">
                            Remaining characters:{" "}
                            <span style={{ color: "red" }}>
                              {remainingChars}
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  1. Only current date Assignments can be edited.<br></br>
                  2. When Send SMS is selected, Assignments details field length
                  will be limited to 159 characters.
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered assignment-table">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Date</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Subject</th>
                        <th>Period</th>
                        <th>Teacher</th>
                        <th>Assignment</th>
                        <th>Attachment</th>
                        <th>Send SMS</th>
                        <th>Send SMS to</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignments.length > 0 ? (
                        currentAssignments.map((assignment, index) => (
                          <tr key={assignment.id}>
                            <td>{indexOfFirstItem + index + 1}</td> {/* ✅ Correct serial no */}
                            <td>{assignment.assignment_date}</td>
                            <td>{assignment.classname}</td>
                            <td>{assignment.sectionname}</td>
                            <td>{assignment.subjectName}</td>
                            <td>{assignment.classperiodName}</td>
                            <td>{assignment.teacherName}</td>
                            <td>
                              <div className="hoverable-text">
                                {assignment.assignment_details.length > 50
                                  ? `${assignment.assignment_details.substring(0, 50)}...`
                                  : assignment.assignment_details}
                                <div className="hover-popup">
                                  {assignment.assignment_details}
                                </div>
                              </div>
                            </td>
                            <td>
                              {assignment.assignment_file ? (
                                <button
                                  className="btn btn-link"
                                  onClick={() => handleDownload(assignment.assignment_file)}
                                >
                                  Download
                                </button>
                              ) : (
                                "No file"
                              )}
                            </td>
                            <td>{assignment.send_sms === "Y" ? "Yes" : "No"}</td>
                            <td>{getSmsRecipientText(assignment.sms_sent_to)}</td>
                            <td>
                              <button
                                disabled={assignment.assignment_date !== todayDate}
                                className="btn btn-primary"
                                onClick={() => handleEditClick(assignment.id)}
                              >
                                Edit
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(assignment.id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            No assignments found for this session
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {/* ✅ Pagination Below Table */}
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                    forcePage={currentPage - 1}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      
  
  );
};

export default AdmAttendanceEntry;
